export default "__VITE_ASSET__KAOQ0npS__"